import React from 'react'
import "./ScaleInstructions.css"
import { Typography } from '../../design_system/StyledComponents/components/Typography'
import ScalePopup from './ScalePopup'
import PriorityHighIcon from '@mui/icons-material/PriorityHigh'

const ScaleInstructions2 = () => {
  return (
    <div className='scale-instructions'>
      <div className='scale-instructions-container'>
        {/* <div className='scale-popup-container'> */}
          <ScalePopup type="ui" />
        {/* </div> */}
        {/* <div className='scale-instructions-notice'>
          <PriorityHighIcon className='scale-instructions-icon' />
          <Typography modifiers={["helpText"]}>
            This step is crucial to scale your entire floorplan correctly in 3D.
          </Typography>
        </div> */}
        <div className='scale-instructions-heading'>
          <Typography modifiers={["header6"]}>Instructions</Typography>
        </div>
        <div className='scale-instructions-list'>
          <div className='scale-instructions-item'>
            <Typography modifiers={["subtitle2","medium"]}>1. Select a Wall</Typography>
            <Typography modifiers={["helpText"]}>Click on the wall for which the measurement is clearly marked on the floorplan image.</Typography>
          </div>
          <div className='scale-instructions-item'>
            <Typography modifiers={["subtitle2","medium"]}>2. Choose the Measurement Unit</Typography>
            <Typography modifiers={["helpText"]}>Use the unit selector above to match the scale used in your floorplan.</Typography>
          </div>
          <div className='scale-instructions-item'>
            <Typography modifiers={["subtitle2","medium"]}>3. Enter the Wall Length</Typography>
            <Typography modifiers={["helpText"]}>Type in the exact length as shown on the floorplan for the selected wall.</Typography>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ScaleInstructions2
